import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { MapExpertAvatarPin } from './maps';
import { getExpertAvatarUrl, resolveMapMarkerIconUrl } from '../utils/imageUtils';
import { anonymizeLastName } from '../utils/anonymizeNames';

export interface ExpertMapMarkerExpert {
  _id: string;
  firstName: string;
  lastName: string;
  profileImage: string;
}

interface ExpertMapMarkerProps {
  expert: ExpertMapMarkerExpert;
  position: google.maps.LatLngLiteral;
}

/**
 * Marqueur carte : même URL d’avatar que {@link ExpertCard} (photo réelle ou logo).
 */
export function ExpertMapMarker({ expert, position }: ExpertMapMarkerProps) {
  const avatarUrl = resolveMapMarkerIconUrl(getExpertAvatarUrl(expert.profileImage));
  const displayName = `${expert.firstName} ${anonymizeLastName(expert.lastName)}`;
  const title = `${displayName} — illustration`;

  return (
    <AdvancedMarker position={position} title={title}>
      <MapExpertAvatarPin src={avatarUrl} alt={displayName} />
    </AdvancedMarker>
  );
}
